import {useUserStore} from '@/store/user'

export default {
  computed: {
    isDefaultCustomer() {
      return this.$auth.loggedIn && useUserStore().loadedCustomerUuid === 'default'
    }
  }
}
